import { SESSION_TERMINATED, USER_EXPIRED } from "redux-oidc";
import { IAction } from '../../commonInterfaces/IAction';
import { actionTypes } from "../../constants/actionTypes";
import Profile from '../../models/Profile';


export interface IProfileState {
  profile: Profile
}

const initialState = {
  profile: Profile
};

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case SESSION_TERMINATED:
    case USER_EXPIRED:
      return Object.assign({}, state, { profile: {}});
    case actionTypes.LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload
      }
    case actionTypes.SWITCH_GENERATOR_VIEW:
      return {
          ...state,
          profile: {
            ...state.profile,
            generatorView: action.payload
          }
        }
    case actionTypes.SWITCH_EDITOR_VIEW:
      return {
        ...state,
        profile: {
          ...state.profile,
          preferredEditor: action.payload
        }
      }
    case actionTypes.SWITCH_EDITOR_THEME:
      return {
        ...state,
        profile: {
          ...state.profile,
          editorTheme: action.payload
        }
      }
    case actionTypes.SWITCH_APP_LANGUAGE:
      return {
        ...state,
        profile: {
          ...state.profile,
          appLanguage: action.payload
        }
      }
    case actionTypes.SWITCH_TOOLTIPS:
      return {
        ...state,
        profile: {
          ...state.profile,
          showTooltips: action.payload
        }
      }
    case actionTypes.TOGGLE_LOGGING:
      return {
        ...state,
        profile: {
          ...state.profile,
          loggingAllowed: action.payload
        }
      }
      case actionTypes.TOGGLE_DELETE_CONFIRMATION:
        return {
          ...state,
          profile: {
            ...state.profile,
            deleteConfirmation: action.payload
        }
      }
      case actionTypes.TOGLE_SHOW_LOG_INFO:
        return {
          ...state,
          profile: {
            ...state.profile,
            showLogInfo: action.payload
        }
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducer/profile.ts